import { createSlice } from "@reduxjs/toolkit";
import { get_all_user_by_type } from "../Actions/AuthUser";
export interface User {
  _id: string;
  firstName: string;
  phoneNumber: string;
  email: string;
}
interface UserState {
  users: User[];
  total: number;
  loading: boolean;
}

const initialState: UserState = {
  users: [],
  total: 0,
  loading: false,
};

const userByTypeSlice = createSlice({
  name: "users",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(get_all_user_by_type.pending, (state) => {
        state.loading = true;
      })
      .addCase(get_all_user_by_type.fulfilled, (state, action) => {
        state.loading = false;

        state.users = action.payload?.data?.response || [];
        state.total = action.payload?.data?.count || 0;
      })

      .addCase(get_all_user_by_type.rejected, (state) => {
        state.loading = false;
      });
  },
});

export default userByTypeSlice.reducer;
